module.exports = __webpack_public_path__ + "img/news-9.c0b3dd69.jpeg";